import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@finitless/shared/lib";
import { isEndpointEnabled } from "@finitless/shared/config";
import { toast } from "sonner";

export const useCreateUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userData) => {
      const response = await apiClient.post("/users", userData);
      return response;
    },
    onSuccess: (data) => {
      // Invalidate and refetch users queries to update the list
      queryClient.invalidateQueries({ queryKey: ["users"] });

      toast.success("User Created Successfully", {
        description: `${data.result?.name} ${data.result?.lastname} has been created successfully!`,
        duration: 5000,
      });
    },
    onError: (error) => {
      toast.error("Create User Failed", {
        description:
          error.message || "Failed to create user. Please try again.",
        duration: 5000,
      });
    },
    enabled: isEndpointEnabled("dashboard", "users"),
  });
};

export default useCreateUser;
